/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'dui': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" _fill="#333" d="M940.4 239.2L403.1 885.3c-1.7 2.6-2.5 5.7-4.5 8.1-25 30-65.4 30-90.4 0l-226-271.8c-25-30-25-78.7 0-108.7s65.4-30 90.4 0L352.2 729 850 130.5c25-30 65.4-30 90.4 0 24.9 30 24.9 78.7 0 108.7z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/dui.js